// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","BarContainer":"BarContainer-25vztk926snydztzd471km8mhmqrfx58bspp5nq1hgu8gyarzehqbgysgz6jty7veumyn1fysq3tu34vjxqyzanpdqata5srhq4xncm","loading":"loading-4ggbnvxdh7uwscy6a537ynkegexkpwz97bdj9usgrzpqaup3y4tuhwdq3yupeshetyxxmdxed7pqfvp6yx8kc29gr5cpmjew5meg2x3","pulse":"pulse-3fhrdkcrcn359svn7ujtpbm4uknmnqczeg385dpy8tq4pq9q9y59swz83xknatf4s9rganpx3utnk4k9kw2gp1rmj883stxdyxz7c9c"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Placeholder/components/ContentBar/ContentBar.module.scss
// module id = 1310
// module chunks = 0